import { Route, Switch, Redirect } from 'react-router-dom';
import WelcomePage from './pages/Welcome';

function App() {
  return (
    <div>
      
      <main>
        <Switch>
          <Route path='/' exact>
            <WelcomePage></WelcomePage>
          </Route>
          <Route path='*'>
            <WelcomePage></WelcomePage>
          </Route>
        </Switch>
      </main>
    </div>
  );
}

export default App;
